import { formDataDefault } from '@/components/dash/postCreator/constante.js'
import { getInfoFile, getErrorNetworkFile } from '@/components/dash/postCreator/utils.js'
import { foreachSaveAllFormData } from '../../postCreator/utils'
const [STORY_HEIGHT, STORY_WIDTH] = [640, 360]


export async function convertOldDraft(draft, pagesId) {
    if (draft.saveAllFormData) return


    if (pagesId && pagesId.length) {
        draft.pages = pagesId
    }
   
    draft.saveAllFormData = {
        main: JSON.parse(JSON.stringify(formDataDefault)),
        networks: {},
        pages: {},
    }
    


    draft.files = {}

    const time = Date.now()
    const formDataMain = draft.saveAllFormData.main
    const files = draft.files
    //function
    function replaceMentions(text) {
        return text.replace(/@\[\MENTIONS-(\d+)\]/g, (match, x) => `@${time + Number(x)}`);
    }

    function replaceHashtags(text) {
        console.log("replaceHashtags",text)
        return text.replace(/#\[\HASHTAGS-(\d+)\]/g, (match, x) => {
            try {
                return `#${draft.hashtagsAdded[Number(x)-1][0]["0"].hashtag}`;
            } catch (error) {
                return `#[HASHTAGS-${x}]`;
            }
        })
    }
    
    async function addFile(url, fileName) {
        
        let idFile = Math.random().toString(36).substr(2, 9);
        const file = await downloadFile(url, fileName)
        const blobUrl = URL.createObjectURL(file); //evite error CORS pour getInfoFile()
        
        const info = await getInfoFile(file, blobUrl);
        const errorNetwork = getErrorNetworkFile(info);

        const fileData = {
            id: idFile,
            url,
            info,
            errorNetwork: errorNetwork,
            isUpload: true,
            failedUpload: false,
            uploadProgress: false,
            percentUpload: 100
        };

        files[idFile] = fileData
        return fileData
    }

    //tab
    if (draft.typePost && draft.typePost == "story") {
        draft.tab = "story"
    }

    //date
    if (draft.scheduling && draft.scheduling.show) {
        //formDataMain.planifiedDate
        const dateInstance = new Date(draft.scheduling.lastScheduled || draft.scheduling.date)
        formDataMain.planifiedDate = {
            date: dateInstance.toISOString().split('T')[0],
            hours: `${draft.scheduling.time['HH']}:${draft.scheduling.time['mm']}`,
            timestamp: dateInstance.getTime()
        }
    }


    draft.idUsersAssigned = []
    draft.requiredValidation = false
    //affectedTo / assignation
    if (draft.affectedTo) {

        if (draft.affectedTo.users && draft.affectedTo.users.length) {
            draft.idUsersAssigned = draft.affectedTo.users.map(user => user.id)
        }

        if (draft.affectedTo.user && !draft.idUsersAssigned.includes(draft.affectedTo.user.id)) {
            draft.idUsersAssigned.push(draft.affectedTo.user.id)
        }

        if (draft.affectedTo.optionValidation) {
            draft.requiredValidation = true
        }
        
    }

    //mentions
    if (draft.mentionsAdded && draft.mentionsAdded.length) {
        let objMention;
        formDataMain.mentions = draft.mentionsAdded.reduce((acc, arrayMentionByNetwork, index) => {
            objMention = {
                mention: {},
                textDefault: "Text default"
            }

            objMention.mention = arrayMentionByNetwork.reduce((acc2, mention) => {
                acc2[mention.network] = {
                    ...mention
                }
                return acc2
            },{})

            acc[time+index+1] = objMention
            return acc
        },{})
    }

    //textContent
    if (draft.form.title) {
        formDataMain.textContent = replaceHashtags(replaceMentions(draft.form.title + (draft.form.description ? `<br>${draft.form.description}` : '')))
    }

    //textComment
    if (draft.form.comments && draft.form.comments.length) {
        formDataMain.comments = draft.form.comments.map((comment)=> replaceHashtags(replaceMentions(comment)))
    }

    //url
    if (draft.form.url) {
        ['facebook', 'google', 'linkedin', 'threads', 'twitter', 'pinterest'].forEach(networkName => {
            formDataMain.formDataNetwork[networkName].snippet.link = draft.form.url
        });
    }

    //snippet custom
    if (draft.snippetTitle) {
        ['facebook','linkedin'].forEach(networkName => {
            formDataMain.formDataNetwork[networkName].snippet.title = draft.snippetTitle
        });
    }
    if (draft.snippet) {
        ['facebook','linkedin'].forEach(networkName => {
            formDataMain.formDataNetwork[networkName].snippet.imageUrl = draft.snippet
        });
    }

    //share story
    if (draft.shareAfterPost) {
        formDataMain.formDataNetwork['instagram'].storification.active = true

        //share story to facebook 
        if (draft.storyShareToFacebook) {
            formDataMain.formDataNetwork['instagram'].storification.shareInFacebook = true
        }
    }

    //localisation
    if (draft.location) {
        const locationByNetwork = JSON.parse(draft.location)
        for (const [networkName, location] of Object.entries(locationByNetwork)) {
            formDataMain.formDataNetwork[networkName].place = location
        }
    }

    //media
    if (draft.multipleMedias.length) {
        formDataMain.files = await Promise.all(
            draft.multipleMedias.map(async (media) => {
                const fileData = await addFile(media.url, media.name);
                return {id: fileData.id};
            })
        );
    }else if (draft.multipleImages.length) {
        console.log('convertOldDraft', 1)
        formDataMain.files = await Promise.all(
            draft.multipleImages.map(async (media) => {
                console.log('convertOldDraft', 2)
                const fileData = await addFile(media.url, media.name);
                console.log('convertOldDraft',3)
                return {id: fileData.id};
            })
        );
        console.log('convertOldDraft',4)
 
    }

    const videos = JSON.parse(draft.videos)
    for (const [key, url] of Object.entries(videos)) {
        let networkName = key.split('_')[0]
        if (url) {

            const fileData = await addFile(url, draft.videoname);
            if (!draft.saveAllFormData.networks[networkName]) draft.saveAllFormData.networks[networkName] = {}
            draft.saveAllFormData.networks[networkName].files = [{
                id: fileData.id
            }]

            const networkSetting = {
                facebook : 'typeMedia',
                linkedin: 'typeMedia',
                twitter: 'typeContent',
            }
            if (networkSetting[networkName]) {

                formDataMain.formDataNetwork[networkName][networkSetting[networkName]] = 'video'
            }
        }
    }

    //sondage linkedin
    if (draft.poll && draft.poll.question) {
        formDataMain.formDataNetwork['linkedin'].survey = {
            active : true,
            duration: {'86400': 'oneDay', '259200': 'threeDay', '604800': 'oneWeek', '1209600': 'twoWeek' }[String(draft.poll.duration)],
            question : draft.poll.question,
            options : draft.poll.options
        }

    //document linkedin
    }else if (draft.typePost == 'document' && draft.form.enclosure) {
        const fileData = await addFile(draft.form.enclosure, draft.form.documentTitle)
        formDataMain.files = [{
            id: fileData.id
        }, ...formDataMain.files]

        formDataMain.formDataNetwork['linkedin'].pdf = {
            title: draft.form.documentTitle || ''
        }
        formDataMain.formDataNetwork['linkedin'].typeMedia = 'pdf'
       
    }
    
    //mention instagram

    if (draft.userTags) {
        let userTags = JSON.parse(draft.userTags)

        if (userTags.list && userTags.list.length) {

            if (userTags.collab && userTags.collab.length) {
                formDataMain.formDataNetwork['instagram'].collaborators = userTags.collab.map((id) => {
                    let mention;
                    userTags.list = userTags.list.filter(m => {
                        if (m.id == id){
                            mention = m
                            return false
                        }
                        return true
                    })
    
                    if (mention) {
                        return {
                            id: mention.username,
                            idFile: null,
                            image: null,
                            name: mention.name,
                            pk: mention.id,
                            timestamp: time + mention.index,
                            x: Number(mention.x) * 100,
                            y: Number(mention.y) * 100,
                        }
                    }
                    return null
                })
            }

            formDataMain.formDataNetwork['instagram'].personsIdentified = userTags.list.map((mention) => ({
                id: mention.username,
                idFile: null,
                image: null,
                name: mention.name,
                pk: mention.id,
                timestamp: time + mention.index,
                x: Number(mention.x) * 100,
                y: Number(mention.y) * 100,
            }))
        }
    }

    //music instagram
    if (draft.musicStory && draft.musicStory.track && draft.musicStory.metadata) {
        formDataMain.formDataNetwork['instagram'].music = {
            metadata: draft.musicStory.metadata,
            track: draft.musicStory.track,
        }
    }
    //tiktok
    if (draft.tiktokOptions) {
        const tiktokOptions = JSON.parse(draft.tiktokOptions)
        formDataMain.formDataNetwork['tiktok'] = {
            visibility: {
                PUBLIC_TO_EVERYONE: 'all',
                MUTUAL_FOLLOW_FRIENDS: 'friends',
                SELF_ONLY: 'me',
            }[tiktokOptions.privacy_level],
            commentDisable: tiktokOptions.comment_disabled,
            useVideoForDuo: !tiktokOptions.duet_disabled,
            useVideoForOtherVideo: !tiktokOptions.stitch_disabled
        }
    }

    //pinterest
    if (draft.form.boardSelected) {
        formDataMain.formDataNetwork['pinterest'].boardSelectedByPage = {
            ['????'] : draft.form.boardSelected
        }
    }

    //youtube
    if (draft.youtubeOptions) {
        const youtubeOptions = JSON.parse(draft.youtubeOptions)
        formDataMain.formDataNetwork['youtube'] = {
            visibility : {
                public: "all",
                private: "private",
                unlisted: "unlisted"
            }[youtubeOptions.privacy_level],
            category : youtubeOptions.category,
            notifySubscribers: youtubeOptions.notifySubscribers,
            contentForChildren: youtubeOptions.madeForKids,
            tags : youtubeOptions.tags && youtubeOptions.tags.length ? youtubeOptions.tags.map(tag => tag.text) : [],
            playlistSelectedByPage : youtubeOptions.playlist ? {
                ['????'] : youtubeOptions.playlist
            } : null
        }
    }

    console.log('convertOldDraft', draft)

    let stories;
    
    if (draft.storyMultiple.length == 1) {
        stories = [{
            storificationData: draft.storificationData,
            url: draft.form.url,
            enclosure: draft.form.enclosure
        }]
    }else{
        stories =  draft.storyMultiple.map(({story})=> (story))
    }
    formDataMain.storification = {}

    let idStory = String(time)
    let indexStory = -1
    for (const {storificationData:story, url:urlStory, enclosure: enclosureStory} of stories) {
        indexStory++
        idStory = String(Number(idStory) + 1)

        formDataMain.storification[idStory] = {}

        //background
        formDataMain.storification[idStory].background = {
            // file : {
            //     id: 1234567890,
            //     type:'image/jpeg',
            //     name:'imageDefault',
            //     size: 0,
            //     url : 'https://i.pinimg.com/236x/84/bd/bc/84bdbc1507a0697fe9288477342b2005.jpg', //temporaire
            // },
            file: null,
        
            color : story.backgroundColor || "#000000",
            size : 'containY', // 'cover' | 'containX' | 'containY'
            position: {"x":50,"y":50},
            transform: {"rotate":0,"scale":1}
        }

        if (enclosureStory) {
            const fileEnclosure = await addFile(enclosureStory);
            formDataMain.storification[idStory].background.file = {
                id: fileEnclosure.id
            }
        }

        //sticker 

        formDataMain.storification[idStory].stickers = {}
        
        let lastIdSticker = String(time)

        //gif
        if (story.gifs && story.gifs.length) {
            story.gifs.forEach((gif, index) => {
                lastIdSticker = String(Number(lastIdSticker) + 1)

                formDataMain.storification[idStory].stickers[lastIdSticker] = {
                    type:'gif',
                    isEditing: false,
                    position : {
                        x: (gif.x + gif.w / 2) / STORY_WIDTH * 100, 
                        y: (gif.y + gif.h / 2) / STORY_HEIGHT * 100
                    },
                    
                    transform: {
                        rotate: gif.angle,
                        scale: gif.scale - 0.2
                    },
                    
                    data : {
                        gif: gif,
                    },
                }
            }); 
        }

        //hashtags
        if (story.hashtags && story.hashtags.length) {
            story.hashtags.forEach((hashtag, index) => {
                lastIdSticker = String(Number(lastIdSticker) + 1)

                formDataMain.storification[idStory].stickers[lastIdSticker] = {
                    type:'hashtag',
                    isEditing: false,
                    position : {
                        x: (hashtag.x + hashtag.w / 2) / STORY_WIDTH * 100, 
                        y: (hashtag.y + hashtag.h / 2) / STORY_HEIGHT * 100
                    },
                    
                    transform: {
                        rotate: hashtag.angle,
                        scale: hashtag.scale
                    },
                    
                    data : {
                        hashtag : hashtag.hashtag,
                        styleVariant: hashtag.color
                    },
                }
            }); 
        }

        //location
        if (story.location) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'localisation',
                isEditing: false,
                position : {
                    x: (story.location.x + story.location.w / 2) / STORY_WIDTH * 100, 
                    y: (story.location.y + story.location.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.location.angle,
                    scale: story.location.scale
                },
                
                data : {
                    place : {...story.location.location, name: story.location.name},
                    styleVariant: story.location.color
                }
            }
        }

        //mention
        if (story.mentions && story.mentions.length) {
            story.mentions.forEach((mention, index) => {
                lastIdSticker = String(Number(lastIdSticker) + 1)

                formDataMain.storification[idStory].stickers[lastIdSticker] = {
                    type:'mention',
                    isEditing: false,
                    position : {
                        x: (mention.x + mention.w / 2) / STORY_WIDTH * 100, 
                        y: (mention.y + mention.h / 2) / STORY_HEIGHT * 100
                    },
                    
                    transform: {
                        rotate: mention.angle,
                        scale: mention.scale
                    },
                    
                    data : {
                        mention : {
                            id: mention.id,
                            pk: mention.pk || null
                        },
                        styleVariant: mention.color
                    },
                }
            }); 
        }

        //music
        if (story.music) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'music',
                isEditing: false,
                position : {
                    x: 50,
                    y: 50
                },
                
                transform: {
                    rotate: 0,
                    scale: 1
                },
                
                data : {
                    music: story.music,
                },
            }
        }

        //survey
        if (story.poll) {
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'survey',
                isEditing: false,
                position : {
                    x: (story.poll.x + story.poll.w / 2) / STORY_WIDTH * 100, 
                    y: (story.poll.y + story.poll.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.poll.angle,
                    scale: story.poll.scale - 0.2
                },
                
                data : {
                    question : story.poll.question,
                    responses : story.poll.options,
                    color : '#0C0F14',
                },
            }
        }

        //product
        if (story.product) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'product',
                isEditing: false,
                position : {
                    x: (story.product.x + story.product.w / 2) / STORY_WIDTH * 100, 
                    y: (story.product.y + story.product.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.product.angle,
                    scale: story.product.scale
                },
                
                data : {
                    products : story.product.items.map(item => ({
                        ...item, 
                        shopId: item.merchantId,
                        description: '',
                        image: null
                    })),
                    font: 'classic-font',
                    color: '#4396F6',
                    styleVariant: 1
                },
            }
        }

        //question
        if (story.question) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'question',
                isEditing: false,
                position : {
                    x: (story.question.x + story.question.w / 2) / STORY_WIDTH * 100, 
                    y: (story.question.y + story.question.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.question.angle,
                    scale: story.question.scale -0.2
                },
                
                data : {
                    question: story.question.text,
                    color: '#FFFFFF',
                },
            }
        }

        //slider
        if (story.slider) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'slider',
                isEditing: false,
                position : {
                    x: (story.slider.x + story.slider.w / 2) / STORY_WIDTH * 100, 
                    y: (story.slider.y + story.slider.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.slider.angle,
                    scale: story.slider.scale
                },
                
                data : {
                    question : story.slider.question,
                    emoji: story.slider.emoji,
                    color: '#FFFFFF',
                },
            }
        }

        //texts
        if (story.texts && story.texts.length) {
            story.texts.forEach((text, index) => {
                lastIdSticker = String(Number(lastIdSticker) + 1)

                formDataMain.storification[idStory].stickers[lastIdSticker] = {
                    type:'text',
                    isEditing: false,
                    position : {
                        x: (text.x + text.w / 2) / STORY_WIDTH * 100, 
                        y: (text.y + text.h / 2) / STORY_HEIGHT * 100
                    },
                    
                    transform: {
                        rotate: text.angle,
                        scale: text.scale
                    },

                    data : {
                        text: text.content,
                        mentions: {},
                        font: ["modern-font", "classic-font","signature-font", "editor-font", "poster-font", "bubble-font", "deco-font", "squeeze-font", "typewriter-font", "strong-font", "meme-font", "elegant-font", "directional-font", "literature-font"][text.font],
                        align: 'center',
                        color: text.color,
                        fontSize: parseFloat(text.size),//27.5
                        background : ["none", "secondary", "primary"][text.background],
                    },
                }
            }); 
        }

        //images
        if (story.layers && story.layers.length) {

            for (const layer of story.layers) {

                lastIdSticker = String(Number(lastIdSticker) + 1)
                const fileData = await addFile(layer.url);

                formDataMain.storification[idStory].stickers[lastIdSticker] = {
                    type:'image',
                    isEditing: false,
                    position : {
                        x: (layer.x + layer.w / 2) / STORY_WIDTH * 100, 
                        y: (layer.y + layer.h / 2) / STORY_HEIGHT * 100
                    },
                    
                    transform: {
                        rotate: layer.angle,
                        scale: layer.scale - 0.2
                    },

                    data : {
                        idFile: fileData.id,
                    },
                }
            }; 
        }
        //link
        if (story.link) {
            
            lastIdSticker = String(Number(lastIdSticker) + 1)

            formDataMain.storification[idStory].stickers[lastIdSticker] = {
                type:'link',
                isEditing: false,
                position : {
                    x: (story.link.x + story.link.w / 2) / STORY_WIDTH * 100, 
                    y: (story.link.y + story.link.h / 2) / STORY_HEIGHT * 100
                },
                
                transform: {
                    rotate: story.link.angle,
                    scale: story.link.scale
                },
                
                data : {
                    link : urlStory,
                    text: story.link.text || '',
                    styleVariant: 1
                },
            }
        }
        
        //highlight
        if (story.hightlight) {
            formDataMain.storification[idStory].highlight = {
                id:story.hightlight,
                text:null,
                img:null,
            }
        }
        //musicReel ?? template ?? textsReel ?? 
    };

    //customization
    if (draft.editPostValue && draft.editPostValue.length) {
        draft.editPostValue.forEach(edit => {
            draft.saveAllFormData.pages[edit.page] = {}

            //textContent
            if (edit.title){
                draft.saveAllFormData.pages[edit.page].textContent = replaceHashtags(replaceMentions(edit.title + (draft.form.description ? `<br>${draft.form.description}` : '')))
            }


            //date
            if (edit.scheduling){
                const dateInstance = new Date(edit.scheduling.date)
                formDataMain.planifiedDate = {
                    date: dateInstance.toISOString().split('T')[0],
                    hours: `${edit.scheduling.time['HH']}:${draft.scheduling.time['mm']}`,
                    timestamp: dateInstance.getTime()
                }
            }

            //comment
        });
    }

    return draft
}

export function patchDraft(draft) {
    try {
        console.log('patchDraft', draft)
        foreachSaveAllFormData(draft.saveAllFormData, (formData,type) => {

            //PATCH 25/06/2025 => nouvelle structure | formDataNetwork.instagram.storification
            if (formData.formDataNetwork && formData.formDataNetwork.instagram && !formData.formDataNetwork.instagram.storification) {
                const storificationDefault = {
                    active: false,
                    shareInFacebook: false,
                    planifiedDate: {
                        date: false,
                        hours: false,
                        timestamp: false
                    },
                }

                if ('shareInStory' in formData.formDataNetwork.instagram) {
                    storificationDefault.active = formData.formDataNetwork.instagram.shareInStory
                }

                if ('shareInStoryFacebook' in formData.formDataNetwork.instagram) {
                    storificationDefault.shareInFacebook = formData.formDataNetwork.instagram.shareInStoryFacebook
                }

                formData.formDataNetwork.instagram.storification = storificationDefault
            }

            //PATCH 25/06/2025 => ajout des tags produit | formDataNetwork.instagram.products
            if (type == 'main' && formData.formDataNetwork && formData.formDataNetwork.instagram && !formData.formDataNetwork.instagram.products) {
                formData.formDataNetwork.instagram.products = []
            }
            
        })

        return draft;
    } catch (error) {
       console.error('Erreur lors du patchDraft:', error, draft); 
    }
    
}

async function downloadFile(url, fileName) {
    try {
        // Télécharger le fichier depuis l'URL
        const response = await fetch(url,{
            cache: 'no-store',
            mode: 'cors',
            method: 'GET',
        });
        const blob = await response.blob();

        // Créer un objet File (simule l'input file)
        const file = new File([blob], fileName || 'downloaded-file', {
            type: blob.type,
        });
        return file;
    } catch (error) {
        console.error('Erreur lors du téléchargement du fichier:', error);
    }
}
